import {
    redirect,
    useActionData,
    useLoaderData,
    useParams,
    useRevalidator,
    useSubmit,
    useSearchParams
} from "react-router-dom";
import ModalUrlWindow from "../../../../components/modalUrl";
import api from "../../../../hooks/useApi";
import {useForm} from "react-hook-form";
import {Autoform} from "../../../../components/forms/autoform";
import jsonToFormData from "../../../../hooks/jsonToFormData";
import {Box} from "@mui/material";
import {showSnackbar} from "../../../../components/snackbarUtils";
import PageTitle from "../../../../components/PageTitle";

export async function loader({request, params}) {
    const id = params.rate_id;
    const searchParams = new URL(request.url).searchParams;
    const children_id = searchParams.get("children_id");
    const rate_id = searchParams.get("rate_id");
    const form = (await api.get(`api/rate/child/${rate_id}/${children_id}/`)).data.form;
    return {form};
}

export async function action({request, params}) {
    const formData = await request.formData();
    const id = params.rate_id;
    const obj_id = params.object_id;
    const rate_ID = formData.get("rate_ID");
    try {
        const response = await api.patch(`api/rate/child/${rate_ID}/0/`, formData);

        if (response.status === 200) {
            showSnackbar("Тариф успішно оновлено!", "success", {
                sx: {backgroundColor: "#1de416", color: "white"}
            });

            setTimeout(() => {
                window.location.href = `/object/${obj_id}/tariffs`; // Перенаправление через 1 сек
            }, 3000);
        } else {
            showSnackbar('Помилка при оновлені тарифу', 'error', {
                sx: {backgroundColor: "#ff0000", color: "white"}
            });
        }
    } catch (e) {
        showSnackbar(`Помилка при оновлені тарифу ${e}`, 'error', {
            sx: {backgroundColor: "#ff0000", color: "white"}
        });
        return {error: e}
    }
    return null;
}

export default function ObjectTariffEdit() {
    const {object_id, rate_id} = useParams();
    const [searchParams] = useSearchParams();
    const rate_ID = searchParams.get("rate_id");
    const submit = useSubmit();

    const revalidator = useRevalidator();
    const {form} = useLoaderData();
    const formHook = useForm();
    const handleSubmitForm = (data) => {
        const formData = jsonToFormData({...data, rate_ID: rate_ID});
        submit(formData, {
            method: 'post'
        })
    }
    const actionData = useActionData();

    return (
        <ModalUrlWindow
            url={`/object/${object_id}/tariffs`}
            title={{text: 'Редагувати тариф'}}
        >
            <PageTitle title={`Редагування тарифу: ${rate_ID || rate_id || "ID"}`} />
            <Autoform
                revalidator={revalidator}
                fields={form}
                formName='HotelRates'
                formHook={formHook}
                onSubmit={handleSubmitForm}
            />
            {actionData?.response && (<Box>
                {JSON.stringify(actionData.response?.data)}
            </Box>)}
        </ModalUrlWindow>
    )
}
